const theme = {
  colors: {
    primary: '#E23734',
    primaryLight: '#FFF1F1',
    grey: '#f0f0f0',
    darkGrey: '#8E8E8E',
    dark: '#000000',
    light: '#FFFFFF',
  },
  breakpoints: ['40em', '52em', '64em'],
  spacing: ['1rem', '2rem', '3rem', '4rem', '5rem', '6rem', '8rem', '10rem'],
  fontSizes: [
    "1.2rem",  "1.4rem", "1.6rem", "1.8rem", "2rem", "2.4rem", "3.2rem", "4.2rem", "5.4rem"
  ],
  gradients: {
    main: `linear-gradient(90deg, #F5F5F5 0%, #FFF1F1 100%);`,
  },
  fonts: {
    body: "Montserrat, sans-serif",
    heading: "Montserrat, sans-serif",
  },
  fontWeights: {
    light: 300,
    body: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    black: 900,
  },
  sidebarWidth: "36rem",
  lineHeights: {
    base: 1.2,
    medium: 1.5,
    large: 1.8,
    xLarge: 2,
  },
}

export default theme;